import { escapeStringRegexp } from '@utils/helpers';
import type * as React from 'react';
import { Link } from 'react-router-dom';
import type { SearchResultProps } from './types';

const highlightSearchString = (searchTerm: string, textToHighlight: string) => {
  if (!searchTerm || !textToHighlight) {
    return null;
  }

  const preparedSplitPattern = searchTerm
    .split(/[\s,]+/)
    .filter((word) => word)
    .map((word: string) => escapeStringRegexp(word))
    .join('|');
  const splitPattern = new RegExp(`(${preparedSplitPattern})`, 'i');
  const splittedText = textToHighlight.split(splitPattern);

  return splittedText.map((word: string, index: number) =>
    index % 2 ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: resonable here
      <span key={word + index} className="highlighted">
        {word}
      </span>
    ) : (
      word
    ),
  );
};

const SearchResult: React.FC<SearchResultProps> = (props: SearchResultProps) => (
  <li className="list-none font-normal text-black py-[30px] px-2.5 border-t border-[#d0d0d0] max-[700px]:pl-0">
    <Link to={props.url} className="no-underline flex flex-row justify-start items-center w-full">
      <div className="min-w-[150px] text-center text-3xl text-[#e2e2e2] max-[700px]:min-w-[50px]">{props.listNumber}</div>
      <div className="search-result__text">
        <h2 className="uppercase text-sm tracking-[1px] leading-6">{props.headline}</h2>
        <p className="font-sans m-0 [&_.highlighted]:text-accent [&_.highlighted]:font-bold">{highlightSearchString(props.searchTerm, props.snippet)}</p>
      </div>
    </Link>
  </li>
);

export { SearchResult };
